import authApi from '../../api/auth-api';
import router from '../../router';

const state = {
  loginFailed: false,
};

const mutations = {
  recoverUser(state) {
    const recoveredUser = JSON.parse(localStorage.getItem('user'));
    if (!recoveredUser) {
      state.status = null;
      state.user = null;
    } else {
      state.status = { loggedIn: true };
      state.user = recoveredUser;
    }
  },
  restaurantsUser(state, data) {
    const recoveredUser = JSON.parse(localStorage.getItem('user'));
    recoveredUser.restaurants = data;
    state.user = recoveredUser;
    localStorage.setItem('user', JSON.stringify(state.user));
  },
  loginRequest(state, user) {
    state.status = { loggingIn: true };
    state.user = user;
  },
  loginSuccess(state, responseData) {
    state.status = { loggedIn: true };
    state.user = {
      id: responseData.user_data.id,
      token: responseData.access_token,
      lang: responseData.user_data.lang,
      name: responseData.user_data.name,
      surname: responseData.user_data.surname,
      restaurants: responseData.user_data.restaurants,
      avatar: responseData.user_data.avatar,
      email: responseData.user_data.email,
      expires_in: new Date(
        new Date().getTime() + responseData.expires_in * 1000
      ).getTime(),
      rememberme: responseData.rememberme,
      roles: responseData.user_data.roles,
    };
    if (responseData.user_data.lang) {
      this.commit('setCurrentLanguage', responseData.user_data.lang);
    }
    state.loginFailed = false;

    //copiamos la información del usuario al localStorage
    localStorage.setItem('user', JSON.stringify(state.user));
  },
  loginFailure(state) {
    state.status = {};
    state.user = null;
    state.loginFailed = true;
  },
  logout(state) {
    state.status = {};
    state.user = null;
  },
  meFailure(state) {
    state.dispatch.logout();
  },
  meSuccess() {
    //actions.logout();
  },
  refreshTokenSuccess(state, responseData) {
    const recoveredUser = JSON.parse(localStorage.getItem('user'));
    recoveredUser.token = responseData.access_token;
    recoveredUser.expires_in = new Date(
      new Date().getTime() + responseData.expires_in * 1000
    ).getTime();
    localStorage.setItem('user', JSON.stringify(recoveredUser));
  },
};

const actions = {
  updateDataLogin(reload = false) {
    authApi.me().then((response) => {
      const recoveredUser = JSON.parse(localStorage.getItem('user'));

      recoveredUser.lang = response.data.user_data.lang;
      recoveredUser.name = response.data.user_data.name;
      recoveredUser.surname = response.data.user_data.surname;
      recoveredUser.avatar = response.data.user_data.avatar;
      recoveredUser.email = response.data.user_data.email;

      localStorage.setItem('user', JSON.stringify(recoveredUser));

      if (reload) {
        location.reload();
      }
    });
  },
  login({ commit, dispatch }, { email, password, rememberme }) {
    commit('loading', true);
    commit('loginRequest', { email });
    authApi.login(email, password).then(
      (response) => {
        response.data.rememberme = rememberme;
        dispatch('getLanguages');
        commit('loginSuccess', response.data);
        commit('notifications', { title: 'Bienvenido/a' });
        location.href = '/admin';
      },
      (error) => {
        commit('loginFailure', error);
        commit('loading', false);
        commit('notifications', {
          title: 'No ha sido posible loguear. Compruebe las credenciales.',
          color: 'danger',
        });
        commit('showNotifications', true);
      }
    );
  },
  recoverPassword({ commit, dispatch }, { email }) {
    commit('loading', true);
    authApi.recoverPassword(email).then(
      (response) => {
        commit('notifications', {
          title:
            'Hemos enviado un email con las instrucciones. Revise su bandeja de entrada.',
        });
        commit('loading', false);
        commit('showNotifications', true);
      },
      (error) => {
        commit('notifications', {
          title: 'No ha sido posible enviar un email.',
          color: 'danger',
        });
        commit('loading', false);
        commit('showNotifications', true);
      }
    );
  },
  resetPassword(
    { commit, dispatch },
    { email, password, password_confirmation, token }
  ) {
    commit('loading', true);
    authApi.resetPassword(email, password, password_confirmation, token).then(
      (response) => {
        commit('notifications', {
          title: 'Contraseña actualizada correctamente.',
        });
        router.push({ name: 'login' }, function () {
          commit('loading', false);
          commit('showNotifications', true);
        });
      },
      (error) => {
        commit('notifications', {
          title: 'No ha sido posible actualizar su contraseña.',
          color: 'danger',
        });
        commit('loading', false);
        commit('showNotifications', true);
      }
    );
  },
  logout({ commit }) {
    authApi.logout();
    commit('logout');
    router.push('/login');
  },
  me({ commit }) {
    authApi.me().then(
      (response) => {
        commit('meSuccess', response.data);
      },
      (error) => {
        commit('meFailure', error);
      }
    );
  },
  checkToken({ commit, dispatch }) {
    const user = JSON.parse(localStorage.getItem('user'));
    const current = new Date().getTime();
    if (current >= user.expires_in) {
      commit('notifications', {
        title: 'Sesión expirada, vuelva a iniciar sesión.',
        color: 'danger',
      });
      router.push({ name: 'login' }, function () {
        commit('loading', false);
        commit('showNotifications', true);
      });
    } else if (user.expires_in - current < 1800000) {
      dispatch('refreshToken');
    }
  },
  refreshToken({ commit }) {
    authApi.refreshToken().then((response) => {
      commit('refreshTokenSuccess', response.data);
    });
  },
};

const getters = {};

export default {
  state,
  mutations,
  actions,
  getters,
};
